var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.wrapClasses, style: _vm.wrapStyles },
    [
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showZeroTrigger,
              expression: "showZeroTrigger"
            }
          ],
          class: _vm.zeroWidthTriggerClasses,
          on: { click: _vm.toggleCollapse }
        },
        [_c("i", { staticClass: "ivu-icon ivu-icon-ios-menu" })]
      ),
      _vm._v(" "),
      _c("div", { class: _vm.childClasses }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm._t("trigger", function() {
        return [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBottomTrigger,
                  expression: "showBottomTrigger"
                }
              ],
              class: _vm.triggerClasses,
              style: { width: _vm.siderWidth + "px" },
              on: { click: _vm.toggleCollapse }
            },
            [_c("i", { class: _vm.triggerIconClasses })]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb55df20", { render: render, staticRenderFns: staticRenderFns })
  }
}